import { INTEGRATION_APP } from '../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
export const getIntegrationAppId = (filterFamilyGroup = '') => {
  if (filterFamilyGroup.startsWith(INTEGRATION_APP)) {
    return filterFamilyGroup.split('-')[1];
  }
  return undefined;
};